__turbopack_context__.v({
  "active": "Letter-module-scss-module__Q01HMa__active",
  "activeBackground": "Letter-module-scss-module__Q01HMa__activeBackground",
  "center": "Letter-module-scss-module__Q01HMa__center",
  "char": "Letter-module-scss-module__Q01HMa__char",
  "desktopLetterSection": "Letter-module-scss-module__Q01HMa__desktopLetterSection",
  "disable": "Letter-module-scss-module__Q01HMa__disable",
  "fixed": "Letter-module-scss-module__Q01HMa__fixed",
  "inactive": "Letter-module-scss-module__Q01HMa__inactive",
  "item": "Letter-module-scss-module__Q01HMa__item",
  "letter": "Letter-module-scss-module__Q01HMa__letter",
  "letters": "Letter-module-scss-module__Q01HMa__letters",
  "lists": "Letter-module-scss-module__Q01HMa__lists",
  "mobileLetterSection": "Letter-module-scss-module__Q01HMa__mobileLetterSection",
  "outerSelected": "Letter-module-scss-module__Q01HMa__outerSelected",
  "relative": "Letter-module-scss-module__Q01HMa__relative",
});
